import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import BaseData from "./BaseData";

var Projects =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Projects, _BaseData);

  function Projects() {
    _classCallCheck(this, Projects);

    return _possibleConstructorReturn(this, _getPrototypeOf(Projects).call(this, "Projects"));
  }

  _createClass(Projects, [{
    key: "GetProjects",
    value: function GetProjects() {
      return axios.get("/api/projects");
    }
  }, {
    key: "GetActiveProjects",
    value: function GetActiveProjects() {
      return axios.get("api/projects/GetActiveProjects");
    }
  }, {
    key: "CreateUserProjects",
    value: function CreateUserProjects(userProject) {
      return axios.post("api/projects/CreateUserProjects", userProject);
    }
  }, {
    key: "DeleteUserProject",
    value: function DeleteUserProject(userProjectId, userId) {
      return axios.delete("api/projects/DeleteUserProject", {
        params: {
          userProjectId: userProjectId,
          userId: userId
        }
      });
    }
  }, {
    key: "GetUserProjects",
    value: function GetUserProjects(userId) {
      return axios.get("api/projects/GetUserProjects/".concat(userId));
    }
  }, {
    key: "GetProjectHeaderInfo",
    value: function GetProjectHeaderInfo(projectId) {
      return axios.get("api/projects/GetProjectHeaderInfo/".concat(projectId));
    }
  }, {
    key: "GetProjectNumber",
    value: function GetProjectNumber(projectId) {
      return axios.get("api/projects/GetProjectNumber/".concat(projectId));
    }
  }, {
    key: "GetProjectNotesPayable",
    value: function GetProjectNotesPayable(projectId) {
      return axios.get("api/projects/GetProjectNotesPayable/".concat(projectId));
    }
  }, {
    key: "GetProjectComments",
    value: function GetProjectComments(projectId) {
      return axios.get("api/projects/GetProjectComments/".concat(projectId));
    }
  }, {
    key: "GetProjectInspectionComments",
    value: function GetProjectInspectionComments(complianceInspectionId) {
      return axios.get("api/projects/GetProjectInspectionComments/".concat(complianceInspectionId));
    }
  }, {
    key: "GetBudgetDCRs",
    value: function GetBudgetDCRs(projectId) {
      return axios.get("api/projects/GetBudgetDCRs/".concat(projectId));
    }
  }, {
    key: "GetPrimaryContact",
    value: function GetPrimaryContact(projectId) {
      return axios.get("api/projects/GetPrimaryContact/".concat(projectId));
    }
  }, {
    key: "GetBillingAddress",
    value: function GetBillingAddress(projectId) {
      return axios.get("api/projects/GetBillingAddress/".concat(projectId));
    }
  }, {
    key: "GetFederalTypes",
    value: function GetFederalTypes(projectId) {
      return axios.get("api/projects/GetFederalTypes/".concat(projectId));
    }
  }, {
    key: "GetNearbyProperties",
    value: function GetNearbyProperties(propertyId, take) {
      return axios.get("api/projects/GetNearbyProperties/".concat(propertyId, "/").concat(take));
    }
  }, {
    key: "CreateProjectComment",
    value: function CreateProjectComment(projectComment) {
      return axios.post("api/projects/CreateProjectComment", projectComment);
    }
  }, {
    key: "UpdateProjectComment",
    value: function UpdateProjectComment(projectComment) {
      return axios.put("api/projects/UpdateProjectComment", projectComment);
    }
  }, {
    key: "GetLRAContact",
    value: function GetLRAContact(projectId) {
      return axios.get("api/projects/GetLRAContact/".concat(projectId));
    }
  }, {
    key: "GetOwnerHistory",
    value: function GetOwnerHistory(projectId) {
      return axios.get("api/projects/GetOwnerHistory/".concat(projectId));
    }
  }, {
    key: "UpdateLRAContact",
    value: function UpdateLRAContact(contact, projectId) {
      return axios.post("api/projects/UpdateLRAContact/".concat(projectId), contact);
    }
  }, {
    key: "CreateProjectComment",
    value: function CreateProjectComment(projectComment) {
      return axios.post("api/projects/CreateProjectComment", projectComment);
    }
  }, {
    key: "IsTaxCreditOnly",
    value: function IsTaxCreditOnly(projectId) {
      return axios.get("api/projects/IsTaxCreditOnly/".concat(projectId));
    }
  }, {
    key: "UpdateProjectComment",
    value: function UpdateProjectComment(projectComment) {
      return axios.put("api/projects/UpdateProjectComment", projectComment);
    }
  }, {
    key: "CreatePropertyRent",
    value: function CreatePropertyRent(PropertyRent) {
      return axios.post("api/PropertyRent/", PropertyRent);
    }
  }, {
    key: "UpdatePropertyRent",
    value: function UpdatePropertyRent(PropertyRent) {
      return axios.put("api/PropertyRent", PropertyRent);
    }
  }, {
    key: "DeletePropertyRent",
    value: function DeletePropertyRent(id) {
      return axios.delete("api/PropertyRent/".concat(id));
    }
  }, {
    key: "DeleteProjectComment",
    value: function DeleteProjectComment(projectCommentId) {
      return axios.delete("api/projects/DeleteProjectComment", {
        params: {
          projectCommentId: projectCommentId
        }
      });
    }
  }, {
    key: "GetProjectInformation",
    value: function GetProjectInformation(id) {
      return axios.get("api/projects/GetProjectInformation/".concat(id));
    }
  }, {
    key: "GetAllProjectInformation",
    value: function GetAllProjectInformation() {
      return axios.get("api/projects/GetAllProjectInformation");
    }
  }, {
    key: "GetProjectsInformationByManagementCompany",
    value: function GetProjectsInformationByManagementCompany(id) {
      return axios.get("api/projects/GetProjectsInformationByManagementCompany/".concat(id));
    }
  }, {
    key: "GetProjectsInformationByUser",
    value: function GetProjectsInformationByUser() {
      return axios.get("api/projects/GetProjectsInformationByUser");
    }
  }, {
    key: "GetProjectsInformationByUserId",
    value: function GetProjectsInformationByUserId(userId) {
      return axios.get("api/projects/GetProjectsInformationByUserId/".concat(userId));
    }
  }, {
    key: "GetCurrentGrossPotentialRent",
    value: function GetCurrentGrossPotentialRent(id) {
      return axios.get("api/projects/GetCurrentGrossPotentialRent/".concat(id));
    }
  }, {
    key: "GetGrossPotentialRent",
    value: function GetGrossPotentialRent(id, start, end) {
      return axios.get("api/projects/GetGrossPotentialRent/".concat(id, "/").concat(start, "/").concat(end));
    }
  }, {
    key: "GetCurrentGrossPotentialRent",
    value: function GetCurrentGrossPotentialRent(id) {
      return axios.get("api/projects/GetCurrentGrossPotentialRent/".concat(id));
    }
  }, {
    key: "GetFinancialNotes",
    value: function GetFinancialNotes(id) {
      return axios.get("api/projects/GetFinancialNotes/".concat(id));
    }
  }, {
    key: "RequiredNonPHAUtilityAllowances",
    value: function RequiredNonPHAUtilityAllowances(id) {
      return axios.get("api/projects/RequiredNonPHAUtilityAllowances/".concat(id));
    }
  }, {
    key: "UpdateFinancialNotes",
    value: function UpdateFinancialNotes(id, note) {
      return axios.post("api/projects/UpdateFinancialNotes", {
        propertyId: id,
        notes: note
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      });
    }
  }, {
    key: "UpdateDecontrolStatus",
    value: function UpdateDecontrolStatus(projectId, decontrolStatusId) {
      return axios.post("api/projects/UpdateDecontrolStatus/".concat(projectId, "/").concat(decontrolStatusId));
    }
  }, {
    key: "GetProjectAuditData",
    value: function GetProjectAuditData(projectId, getDetail) {
      return axios.get("api/projects/GetProjectAuditData/".concat(projectId, "/").concat(getDetail));
    }
  }, {
    key: "RemoveProjectPermissions",
    value: function RemoveProjectPermissions(projectId) {
      return axios.get("api/projects/RemoveProjectPermissions/".concat(projectId));
    }
  }, {
    key: "RemoveProjectContacs",
    value: function RemoveProjectContacs(projectId) {
      return axios.get("api/projects/RemoveProjectContacs/".concat(projectId));
    }
  }, {
    key: "GetOwner",
    value: function GetOwner(projectId) {
      return axios.get("api/projects/GetOwner/".concat(projectId));
    }
  }, {
    key: "GetProjectWithInclusions",
    value: function GetProjectWithInclusions(projectId) {
      return axios.get("api/projects/GetProjectWithInclusions/".concat(projectId));
    }
  }, {
    key: "GetDecontrolScheduleStatus",
    value: function GetDecontrolScheduleStatus(projectId) {
      return axios.get("api/projects/GetDecontrolScheduleStatus/".concat(projectId));
    }
  }, {
    key: "UpdateDecontrolSchedule",
    value: function UpdateDecontrolSchedule(projectId, show) {
      axios.post("api/projects/UpdateDecontrolSchedule/".concat(projectId, "/").concat(show));
    }
  }]);

  return Projects;
}(BaseData);

export default new Projects();